import { render } from "./FRangeInput.vue?vue&type=template&id=afbf3772&scoped=true"
import script from "./FRangeInput.vue?vue&type=script&lang=js"
export * from "./FRangeInput.vue?vue&type=script&lang=js"

import "./FRangeInput.vue?vue&type=style&index=0&id=afbf3772&scoped=true&lang=scss"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afbf3772"]])

export default __exports__